import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Column - Logo & Description */}
        <div className="footer-column footer-brand">
          <div className="footer-logo">
            <img
              src="/images/logo-beyaz.png"
              alt="Cennetin Çocukları"
              className="footer-logo-image"
            />
          </div>
          <p className="footer-description">
            Cennetin Çocukları 4-6 yaş grubu okulumuz, çocuklarınızın manevi ve dünyevi gelişimini destekleyen sevgi dolu bir eğitim sunmaktadır.
          </p>
        </div>

        {/* Column 2 - Quick Links */}
        <div className="footer-column">
          <h3 className="footer-title">Hızlı Bağlantılar</h3>
          <div className="footer-title-line"></div>
          <ul className="footer-links">
            <li><a href="#home">Ana Sayfa</a></li>
            <li><a href="#about">Hakkımızda</a></li>
            <li><a href="#education">Eğitim Sistemimiz</a></li>
            <li><a href="#teachers">Öğretmenlerimiz</a></li>
            <li><a href="#gallery">Galeri</a></li>
            <li><a href="#contact">İletişim</a></li>
          </ul>
        </div>

        {/* Column 3 - Contact */}
        <div className="footer-column">
          <h3 className="footer-title">İletişim</h3>
          <div className="footer-title-line"></div>
          <ul className="footer-contact">
            <li>
              <i className="fas fa-map-marker-alt"></i>
              <a href="https://maps.app.goo.gl/gnzFmE2588jG9vYU7" target="_blank" rel="noopener noreferrer">
                Mevlana Mah. Hasan Kerim Cad. No:1 Esenyurt/İstanbul
              </a>
            </li>
            <li>
              <i className="fas fa-phone"></i>
              <a href="tel:05389466443">0538 946 64 43</a>
            </li>
            <li>
              <i className="fas fa-envelope"></i>
              <a href="mailto:info@cennetincocuklari.com">info@cennetincocuklari.com</a>
            </li>
            <li>
              <i className="fas fa-clock"></i>
              <span>Pazartesi - Cuma: 08:00 - 17:00</span>
            </li>
          </ul>
        </div>

        {/* Column 4 - CTA */}
        <div className="footer-column footer-cta-column">
          <h3 className="footer-title">Randevu Alın</h3>
          <div className="footer-title-line"></div>
          <p className="footer-cta-text">
            Okulumuz hakkında detaylı bilgi almak ve ziyaret randevusu oluşturmak için hemen bizi arayın.
          </p>
          <a href="tel:05389466443" className="footer-button">
            <i className="fas fa-phone-alt"></i>
            Hemen Ara
          </a>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>2025 Cennetin Çocukları. Tüm hakları saklıdır.</p>
      </div>
    </footer>
  );
};

export default Footer;
